import {ScrollBar} from "./helper/ScrollBar";
import {ModalStructure} from './modal/ModalStructure';

export class Modal extends ModalStructure{
    constructor(){
        super();
        this.modalTriggers = document.querySelectorAll('[data-popup-trigger]');
        this.bodyBlackout = document.querySelector('.body-blackout');
        this.popupModal = null;

        this.modalTriggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                const { popupTrigger } = trigger.dataset;
                this.popupModal = document.querySelector(`[data-popup-modal="${popupTrigger}"]`);
                this.openModal();

                this.popupModal.querySelector('.popupModal__close').addEventListener('click', () => {
                    this.closeModal();
                });

                this.bodyBlackout.addEventListener('click', () => {
                    this.closeModal();
                })
            })
        });

        document.addEventListener('keyup', (e) => {
            let code = e.code;
            if (code === 'Escape') {
                this.closeModal();
            }
        });
    }

    openModal(){
        ScrollBar.disable();
        setTimeout(() => {
            this.popupModal.classList.add('popupModal--isVisible');
            this.bodyBlackout.classList.add('is-blacked-out');
        }, 10);
    }

    closeModal(){
        this.popupModal.classList.remove('popupModal--isVisible');
        this.bodyBlackout.classList.remove('is-blacked-out');
        setTimeout(() => {
            ScrollBar.enable();
        }, 500);
    }
}